import React from "react";
import { channelLabel, testSkipReason } from "./broadcastOptions";

/**
 * Итог пробной отправки — по строке на каждую запрошенную поверхность.
 *
 * Схлопывать строки в одну нельзя: вся ценность репетиции как раз в том, чтобы
 * увидеть, что в приложение уведомление ушло, а в браузере живой подписки нет.
 * Одна сводная строка «частично» об этом не говорит ничего.
 */

const STATUS_CLASS = {
	sent: "is-ok",
	skipped: "is-warn",
	failed: "is-error",
	partial: "is-warn",
};

const OVERALL_TEXT = {
	sent: "Уведомление доставлено — это настоящий пуш, человек его уже увидел.",
	partial:
		"Дошло не на все поверхности. Ниже видно, куда ушло, а где человека просто нет — второе не поломка.",
	skipped:
		"Никуда не ушло. Причина ниже: это свойство конкретного получателя, а не сбой отправки.",
	failed: "Отправка сорвалась — это уже настоящая ошибка, смотрите причину ниже.",
};

// Поверхности без картинки — самое частое место для неверного вывода: человек
// проверяет на айфоне, картинки не видит и решает, что сломана рассылка.
const imageLine = (row) => {
	if (row.imageSupported) {
		return "Картинка показана вместе с текстом.";
	}
	return `${row.imageNote || "Картинки на этой поверхности не будет."} Текст уведомления дошёл полностью — это не сбой отправки.`;
};

const PushTestResult = ({ result }) => {
	if (!result) return null;

	// results появился вместе с выбором канала. Если сервер почему-то ответил
	// по-старому, показываем прежнюю одну строку, а не пустоту.
	const rows =
		Array.isArray(result.results) && result.results.length > 0
			? result.results
			: [
					{
						jobId: result.jobId,
						channel: result.channel,
						status: result.status,
						error: result.error,
						imageSupported: false,
						imageNote: null,
					},
				];

	const withImage = Boolean(result.imageUrl);

	return (
		<div className="broadcasts-page__result">
			<p
				className={`broadcasts-page__status ${
					STATUS_CLASS[result.status] || "is-warn"
				}`}
				style={{ marginTop: 0 }}
			>
				Пользователь {result.userId}.{" "}
				{OVERALL_TEXT[result.status] || `Статус: ${result.status || "неизвестен"}.`}
			</p>

			<div className="broadcasts-page__result-rows">
				{rows.map((row) => (
					<div
						key={`${row.channel}-${row.jobId}`}
						className={`broadcasts-page__result-row ${
							STATUS_CLASS[row.status] || "is-warn"
						}`}
					>
						<div className="broadcasts-page__result-channel">
							{channelLabel(row.channel)}
						</div>
						<div className="broadcasts-page__result-body">
							{row.status === "sent" && (
								<p className="broadcasts-page__status is-ok" style={{ margin: 0 }}>
									Доставлено. Задание №{row.jobId}.
								</p>
							)}
							{row.status === "skipped" && (
								<p
									className="broadcasts-page__status is-warn"
									style={{ margin: 0 }}
								>
									Не отправлено. {testSkipReason(row.error)}
								</p>
							)}
							{row.status !== "sent" && row.status !== "skipped" && (
								<p
									className="broadcasts-page__status is-error"
									style={{ margin: 0 }}
								>
									Сбой отправки: {row.error || "причина не указана"}.
								</p>
							)}

							{withImage && row.status === "sent" && (
								<p
									className={`broadcasts-page__hint${
										row.imageSupported ? "" : " broadcasts-page__hint--warn"
									}`}
									style={{ margin: "4px 0 0" }}
								>
									{imageLine(row)}
								</p>
							)}
						</div>
					</div>
				))}
			</div>

			{rows.some((row) => row.status === "skipped") && (
				<p className="broadcasts-page__hint broadcasts-page__hint--beside">
					В массовой рассылке такие люди попадут в «пропущено» — это не сбой
					отправки.
				</p>
			)}
		</div>
	);
};

export default PushTestResult;
